import type { OpenSignupRow } from "../../components/dashboard/OpenSignups/OpenSignupDataTable";

export const buildOpenSignUpRows = (data: {
  rotations: any[];
  sessions: any[];
}): OpenSignupRow[] => {
  return data.sessions.map((s) => {
    const rotation = data.rotations.find((r) => r._id === s.rotation);

    return {
      rotationId: rotation._id,
      rotationDate: rotation.date,
      sessionId: s._id,
      sessionName: s.name,
      multiWeek: !s.singleton,
    };
  });
};
